import React from 'react'
import { Provider } from 'react-redux'
import { ThemeProvider } from 'styled-components/macro'
import { GridThemeProvider } from 'styled-bootstrap-grid'
import AppContainer from './App'
import { theme, gridTheme } from '../../utils/theme'

import { store } from '../../features/store'

export const Root = () => (
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <GridThemeProvider gridTheme={gridTheme}>
        <AppContainer />
      </GridThemeProvider>
    </ThemeProvider>
  </Provider>
)
